module.exports = __webpack_public_path__ + "static/media/lungs.3a43ad14.ogg";